import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';

class OrderItems extends Component {
    render() {
        const { cart } = this.props;

        return (
            <div className="review-section cart-review-section">
                <table className="cart-review-table">
                    <tbody>
                        {cart.items.map((item, i) => {
                            return [
                                <tr key={i.id} className="item normal-item">
                                    <td className="title">{item.title}</td>
                                    <td className="price">
                                        <NumberFormat
                                            value={item.price_final}
                                            displayType={'text'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    </td>
                                    <td className="qty">{item.qty}</td>
                                    <td className="total">
                                        <NumberFormat
                                            value={item.total}
                                            displayType={'text'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    </td>
                                </tr>,
                                <tr key={item.sku} className="item variant-item">
                                    <td>
                                        <div className="line-item">
                                            {item.variant ? (
                                                <div className="line-item">
                                                    <span className="line-title">
                                                        {item.variant.title}
                                                    </span>
                                                </div>
                                            ) : (
                                                <span className="line-title">
                                                    {item.sku}
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="price">
                                        <NumberFormat
                                            value={
                                                item.original_price
                                                    ? item.original_price
                                                    : ''
                                            }
                                            style={{
                                                textDecoration: 'line-through',
                                                color: '#a92323',
                                            }}
                                            displayType={'text'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    </td>
                                    <td
                                        className="qty"
                                        style={{
                                            textDecoration: 'line-through',
                                            color: '#a92323',
                                        }}
                                    >
                                        {item.discount_qty
                                            ? item.discount_qty &&
                                              item.discount_qty <= item.qty
                                                ? item.discount_qty
                                                : item.qty
                                            : ''}
                                    </td>
                                    <td className="total">
                                        <NumberFormat
                                            value={
                                                item.original_total
                                                    ? item.original_total
                                                    : ''
                                            }
                                            style={{
                                                textDecoration: 'line-through',
                                                color: '#a92323',
                                            }}
                                            displayType={'text'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    </td>
                                </tr>,
                            ];
                        })}
                        {cart.codes.map((code, i) => {
                            if (code.code_type === 'general') {
                                return (
                                    <tr key={i} className="item item--coupon">
                                        <td className="title">{code.code}</td>
                                        <td className="price">
                                            {code.sale_type === 'dollar' ? (
                                                <NumberFormat
                                                    value={code.value}
                                                    displayType={'text'}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    prefix={'$'}
                                                />
                                            ) : (
                                                <NumberFormat
                                                    value={code.value}
                                                    displayType={'text'}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    suffix={'%'}
                                                />
                                            )}
                                        </td>
                                        <td className="qty" />
                                        <td className="total">
                                            <NumberFormat
                                                value={code.total}
                                                displayType={'text'}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                prefix={'$'}
                                            />
                                        </td>
                                    </tr>
                                );
                            } else {
                                return [
                                    <tr key={i} className="item item--coupon">
                                        <td className="title">Coupon ({code.code})</td>
                                    </tr>,
                                    <tr
                                        colSpan="4"
                                        key={i + 1}
                                        className="item variant-item"
                                    >
                                        <td className="title">
                                            {code.message ? code.message : ''}
                                        </td>
                                    </tr>,
                                ];
                            }
                        })}
                    </tbody>
                    <tfoot>
                        <tr className="sub-total">
                            <th colSpan="3">Sub Total</th>
                            <td className="shipping">
                                <NumberFormat
                                    value={cart.sub_total}
                                    displayType={'text'}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </td>
                        </tr>
                        <tr className="shipping">
                            <th colSpan="3">Shipping & Handling</th>
                            <td className="shipping">
                                {cart.shipping && (
                                    <NumberFormat
                                        value={cart.shipping.cost}
                                        displayType={'text'}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                )}
                            </td>
                        </tr>

                        {/* TAXES */}
                        {Object.keys(cart.taxes).map((taxKey, i) => {
                            // Do not show total
                            if (taxKey === 'total') return null;

                            // Get tax total
                            const taxTotal = cart.taxes[taxKey];

                            // Do not show empty values
                            if (taxTotal === 0) return null;

                            // Finally, return tax row
                            return (
                                <tr key={i} className="tax">
                                    <th colSpan="3">{taxKey}</th>
                                    <td className="tax">
                                        <NumberFormat
                                            value={taxTotal}
                                            displayType={'text'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    </td>
                                </tr>
                            );
                        })}

                        {!!cart.donation &&
                            cart.donation.map((donation, i) => {
                                return (
                                    <tr className="donation" key={i}>
                                        <th colSpan="3">
                                            Donation{' '}
                                            {!!donation.charity
                                                ? '(' + donation.charity + ')'
                                                : ''}
                                        </th>
                                        <td className="tax">
                                            <NumberFormat
                                                value={donation.amount}
                                                displayType={'text'}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                prefix={'$'}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}

                        <tr className="total">
                            <th colSpan="3">Total</th>
                            <td className="total">
                                <NumberFormat
                                    value={this.props.cart.total}
                                    displayType={'text'}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        cart: state.cart,
    };
};

export default connect(mapStateToProps)(OrderItems);



// WEBPACK FOOTER //
// ./src/components/checkout/order-review/OrderItems.js